import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, Route, UrlSegment, ActivatedRouteSnapshot } from '@angular/router';
import { take, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { SessionService } from 'src/app/store/session/session.service';

@Injectable({
  providedIn: 'root'
})
export class SessionGuard  {

  constructor(
    private router: Router,
    private sessionService: SessionService
  ) { }


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.validate(state);
  }

  private validate(state: RouterStateSnapshot) {
    return this.sessionService.isAuthenticated().pipe(
      take(1),
      switchMap(isLoggedIn => {
        if (!isLoggedIn) {
          this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        }
        return of(isLoggedIn);
      })
    );
  }
}
